<div class="storage-full tw-pt-8">
  <files-list
    [isListView]="isListView"
    (isListViewChange)="isListViewChange($event)"
  ></files-list>
</div>
